
export default {
    estadoCivil: {},
    estadosCivies: []
}